import { FETCH_CONNECTABLE_OBJECTS, UPDATE_CONNECTABLE_OBJECT, UPDATE_CONNECTABLE_OBJECTS } from '../actions';

export default function(state = [], action) {
  switch (action.type) {
  case FETCH_CONNECTABLE_OBJECTS:
    return action.payload;
  case UPDATE_CONNECTABLE_OBJECT: {
    const updatedConnectableObject = action.payload;
    return state.map((connectableObject) => {
      return (connectableObject.id === updatedConnectableObject.id ? updatedConnectableObject : connectableObject);
    });
  }
  case UPDATE_CONNECTABLE_OBJECTS: {
    let newState = [...state];
    action.payload.forEach((updatedObject) => {
      newState = newState.map(object => object.id === updatedObject.id ? { ...updatedObject } : { ...object });
    });
    return newState;
  }
  }

  return state;
}
